<app-uni-page [parent]="this" *ngIf="isPageReady" pageTitle="Administration: Proximity API"
  [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full" *ngIf="isPageReady">
    <!-- Toolbar -->
    <div class="flex items-center gap-4 mx-4 my-3">
      <div class="flex items-center gap-2" *ngIf="!shouldShowPendingOnly">
        <p-checkbox
          [(ngModel)]="shouldShowErrorsOnly"
          (ngModelChange)="refreshQuery()"
          [binary]="true"
          [ngModelOptions]="{ standalone: true }"
          inputId="shouldShowErrorsOnly"
        ></p-checkbox>
        <label for="shouldShowErrorsOnly">Show errors only</label>
      </div>

      <div class="flex items-center gap-2" *ngIf="!shouldShowErrorsOnly">
        <p-checkbox
          [(ngModel)]="shouldShowPendingOnly"
          (ngModelChange)="refreshQuery()"
          [ngModelOptions]="{ standalone: true }"
          [binary]="true"
          inputId="shouldShowPendingOnly"
        ></p-checkbox>
        <label for="shouldShowPendingOnly">Show pending submissions only</label>
      </div>

      <p-floatlabel variant="in">
        <p-datepicker
          [(ngModel)]="afterDate"
          (ngModelChange)="refreshQuery()"
          inputId="afterDate"
          [style]="{ minWidth: '160px' }"
        ></p-datepicker>
        <label for="afterDate">Created After</label>
      </p-floatlabel>
    </div>

    <!-- TabView with Grids -->
    <p-tabView (onChange)="onTabChanged($event)" class="flex-1 min-h-0 uni-tabview">
      <p-tabPanel header="Simple Submissions">
        <app-ag-grid [gridOptions]="bulkSubGridOptions" class="h-full"></app-ag-grid>
      </p-tabPanel>
      <p-tabPanel header="Combination Submissions">
        <app-ag-grid [gridOptions]="cmbSubGridOptions" class="h-full"></app-ag-grid>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button pButton type="button" class="p-button-raised" [disabled]="totalRemainingCount==0"
      (click)="submitSupplierData()">
      <span>Submit Supplier Data to Proximity</span>
      <span>&nbsp;&nbsp;&nbsp;&nbsp; Items remaining: {{ totalRemainingCount }}</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="getApiVersion()">
      <span>Check API Version</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="addToken()" [disabled]="!isSystemAdmin">
      <span>Update Proximity Token</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="generateToken()" [disabled]="!isSystemAdmin">
      <span>Generate API Token</span>
    </button>
  </div>
</ng-template>